import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="flex items-center space-x-2">
      {/* Light mode icon */}
      <svg 
        className="w-5 h-5 text-text-light-secondary dark:text-text-dark-secondary" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <circle cx="12" cy="12" r="5" strokeWidth="2"/>
        <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" strokeWidth="2"/>
      </svg>
      
      {/* Toggle switch */}
      <button
        onClick={toggleTheme}
        className={`relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary ${
          theme === 'dark' 
            ? 'bg-gray-700' 
            : 'bg-gray-200'
        }`}
        role="switch"
        aria-checked={theme === 'dark'}
        aria-label="Toggle dark mode"
      >
        <span className="sr-only">Toggle theme</span>
        <span
          className={`pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200 ${
            theme === 'dark' ? 'translate-x-5' : 'translate-x-0'
          }`}
        />
      </button>
      
      {/* Dark mode icon */}
      <svg 
        className="w-5 h-5 text-text-light-secondary dark:text-text-dark-secondary" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" strokeWidth="2"/>
      </svg>
    </div>
  );
};

export default ThemeToggle;
